import axios from "axios";
import { constants, environmentVariables } from "../Url/Constants"
import Cookies from "js-cookie";
import { useJwt, isExpired } from "react-jwt";
import { logout } from "./AuthUtil";
//import { Cookie } from "express-session";

//const token = Cookies.get('X_TKN');
let url;
if (environmentVariables.envLevel !== "LOCAL") {
    url = window.location.href;
} else {
    url = "https://availability-dev-ui.cloudrts.net/";
    //alert(url)
}
const axiosInstance = axios.create({
    baseURL: url
});
// request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        
        
        if (environmentVariables.envLevel === "LOCAL") {
            //alert("local")
        } else {
            const newtoken = Cookies.get('X_TKN');
            console.log("new token is", newtoken)
            if (isExpired(newtoken)) {
                logout(true)
                //throw new Error("token is expired")
            }
        }
        
        
        return config
    }, (error) => {
        return Promise.reject(error)
    }

) 


axiosInstance.interceptors.response.use(
    (response) => {
        console.log("intercept response", response);
        console.log("header intercepter", response.headers['authorization']);
        if(response.headers['authorization'] !== undefined) {
            Cookies.set("X_TKN",response.headers['authorization'])
        }
        return response;
    }, (error) => {
        if(error.response.status === 401) {
            logout(true)
        }
        return Promise.reject(error)
    }



)
export default axiosInstance;